import { api } from '../api';

export const homeService = {
  async fetchInformations(params) {
    return api.get('home', { params });
  },
};